import { useQuery } from '@tanstack/react-query';
import {
  Streamingpackage,
  StreamingpackagePrices,
} from '../../../interfaces/StreamingProvider.interface';
import { getStreamingPackage } from '../../../services/api/getStreamingPackage';

export const useStreamingProviders = () => {
  const { data, isLoading, error } = useQuery<Streamingpackage[], string>({
    queryKey: ['streamingpackage'],
    queryFn: () => {
      return getStreamingPackage();
    },
  });

  const providers = data ?? [];
  const providerNames: string[] = providers.map((provider) => provider.name);
  const providerPrices: StreamingpackagePrices[] = providers.map(
    (provider) => ({
      name: provider.name,
      monthly_price: provider.monthly_price_cents,
      monthly_price_yearly_subscription:
        provider.monthly_price_yearly_subscription_in_cents,
    })
  );

  return {
    providers,
    providerNames,
    providerPrices,
    loading: isLoading,
    error,
  };
};
